var dropdown = require('./dropdown');

// build state select depending on country
var select = function (stateName, stateLabel, optionsStatesDesktop, optionsStatesMobile, required) {
    var requiredText = required ? 'required' : '';
    return '<div class="custom-dropdown-container state-dropdown ' + stateName + ' form-group ' + requiredText + ' state-generated">'
        + '<label class="form-control-label" for="state">' + stateLabel + '</label>'
        + '<div class="dropdown custom-dropdown">'
        + '<button class="custom-dropdown-toggle dropdown-toggle checkstate" id="checkstate" data-toggle="dropdown" type="button">&mdash;</button>'
        + '<div class="dropdown-menu" aria-labelledby="shippingStatedefault">' + optionsStatesDesktop + '</div>'
        + '<div class="invalid-feedback custom-dropdown-feedback">Please select a State</div>'
        + '</div>'
        + '<div class="mobile-select-container">'
        + '<select class="form-control mobile-select state-select" id="shippingStatedefault" name="' + stateName + '" aria-required="' + required + '" ' + requiredText + '>'
        + '<option value="">-</option>' + optionsStatesMobile
        + '</select>'
        + '<div class="invalid-feedback custom-dropdown-feedback">Please select a State</div>'
        + '</div>';
};

// build state input depending on country
var inputState = function (stateName, stateLabel, stateCode) {
    var requiredText = stateCode.required ? 'required' : '';
    return '<div class="form-group">'
        + '<label class="form-control-label" for="' + stateName + '">' + stateLabel + '</label>'
        + '<input type="text" class="form-control" id="shippingStatedefault" name="' + stateName + '" ' + requiredText + '>'
        + '<div class="invalid-feedback custom-dropdown-feedback">Please select a State</div>'
        + '</div>';
};

// build zip input depending on country
var zipInput = function (required, zipName, pattern, label) {
    var requiredText = required ? 'required' : '';
    return '<div class="form-group ' + required + '">'
        + '<label class="form-control-label" for="' + zipName + '">' + label + '</label>'
        + '<input type="text" class="form-control" name="' + zipName + '" pattern="' + pattern + '" ' + requiredText + '>'
        + '<div class="invalid-feedback custom-dropdown-feedback">Please enter a ZIP Code</div>'
        + '</div>';
};

/**
 * build state field depending on selected country
 * @param {string} countryCode - country code id
 * @param {Object} countrySelect - country select
 * @param {Object} event - country select event
 */
function buildStateSelector(countryCode, countrySelect, event) {
    var countryListVal = $('#countryList').val();
    var countryListObj = JSON.parse(countryListVal);
    var countryData = countryListObj[countryCode];
    var $currentFormStateWrapper = countrySelect.closest('.state-parent-form');
    var stateName = $currentFormStateWrapper.find('.state-wrapper').data('state-name');
    var stateLabel = countryCode === 'US' ? 'STATE' : 'STATE / PROVINCE / REGION';
    var addressTwoLabel = 'ADDRESS 2';
    var $addressTwo = $currentFormStateWrapper.find('.shippingAddressTwo');
    var hasStates = countryData
        && countryData.dynamicForms
        && countryData.dynamicForms.addressDetails
        && countryData.dynamicForms.addressDetails.stateCode
        && countryData.dynamicForms.addressDetails.stateCode.values;
    var skipState = countryData
        && countryData.dynamicForms
        && countryData.dynamicForms.addressDetails
        && countryData.dynamicForms.addressDetails.stateCode
        && countryData.dynamicForms.addressDetails.stateCode.skip;

    if ($addressTwo.length) {
        $addressTwo.prev().text(addressTwoLabel);
    }

    if (hasStates) {
        var optionsStatesMobile = countryData.dynamicForms.addressDetails.stateCode.values.map(function (state) {
            return '<option value="' + state.value + '" id="' + state.value + '">' + state.label + '</option>';
        }).join('');

        var optionsStatesDesktop = countryData.dynamicForms.addressDetails.stateCode.values.map(function (state) {
            return '<div data-option-val="' + state.value + '" id="' + state.value + '" class="dropdown-item">' + state.label + '</div>';
        }).join('');

        $currentFormStateWrapper.find('.state-wrapper').html(select(stateName, stateLabel, optionsStatesDesktop, optionsStatesMobile, countryData.dynamicForms.addressDetails.stateCode.required));
        dropdown.updateValidationStyle();
    } else if (skipState) {
        $currentFormStateWrapper.find('.state-wrapper').empty();

        if (countrySelect.closest('.shipping-form').length) {
            $(document).trigger('emptyStates:init', [event]);
        }
    } else {
        $currentFormStateWrapper.find('.state-wrapper').html(inputState(stateName, stateLabel, countryData.dynamicForms.addressDetails.stateCode));

        if (countrySelect.closest('.shipping-form').length) {
            $(document).trigger('emptyStates:init', [event]);
        }
    }
}

/**
 * build postal field depending on selected country
 * @param {string} countryCode - country code id
 * @param {Object} countrySelect - country select
 */
function buildPostalInput(countryCode, countrySelect) {
    var countryListVal = $('#countryList').val();
    var countryListObj = JSON.parse(countryListVal);
    var countryData = countryListObj[countryCode];
    var $currentFormZipWrapper = countrySelect.closest('.state-parent-form');
    var zipName = $currentFormZipWrapper.find('.zip-wrapper').data('zip-name');
    var skipPostalCode = countryData
        && countryData.dynamicForms
        && countryData.dynamicForms.addressDetails
        && countryData.dynamicForms.addressDetails.postalCode
        && countryData.dynamicForms.addressDetails.postalCode.skip;
    var postalCodeRequired = countryData
        && countryData.dynamicForms
        && countryData.dynamicForms.addressDetails
        && countryData.dynamicForms.addressDetails.postalCode
        && countryData.dynamicForms.addressDetails.postalCode.required;
    var postalCodePattern = countryData
        && countryData.dynamicForms
        && countryData.dynamicForms.addressDetails
        && countryData.dynamicForms.addressDetails.postalCode
        && countryData.dynamicForms.addressDetails.postalCode.pattern;
    var required = postalCodeRequired ? 'required' : '';
    var pattern = postalCodePattern || '';
    var label = countryCode === 'US' ? 'ZIP CODE' : 'Zip / Postal Code';

    if (skipPostalCode) {
        $currentFormZipWrapper.find('.zip-wrapper').empty();
    } else {
        $currentFormZipWrapper.find('.zip-wrapper').html(zipInput(required, zipName, pattern, label));

        if (!pattern) {
            $currentFormZipWrapper.find('.zip-wrapper input').removeAttr('pattern');
        }
    }
}

/**
 * Show validation error
 * @param {jQuery.event} e - Event to be canceled if form is invalid.
 * @returns {void}
 */
function showErrors(e) {
    e.preventDefault();
    this.setCustomValidity('');
    if (!this.validity.valid) {
        var validationMessage = this.validationMessage;
        $(this).addClass('is-invalid');
        if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
            validationMessage = $(this).data('pattern-mismatch');
        }
        if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
            && $(this).data('range-error')) {
            validationMessage = $(this).data('range-error');
        }
        if ((this.validity.tooLong || this.validity.tooShort)
            && $(this).data('range-error')) {
            validationMessage = $(this).data('range-error');
        }
        if (this.validity.valueMissing && $(this).data('missing-error')) {
            validationMessage = $(this).data('missing-error');
        }
        if (this.validity.valueMissing && $(this).closest('form').hasClass('share-form')) {
            validationMessage = 'Required field';
        }
        $(this).parents('.form-group').find('.invalid-feedback')
            .text(validationMessage);

        // Add 'is-invalid' for custom select
        if ($(this).hasClass('mobile-select')) {
            var customdropdown = $(this).parent().siblings('.custom-dropdown');
            var desktopdropdown = customdropdown.children('.custom-dropdown-toggle');
            var label = customdropdown.siblings('label');

            desktopdropdown.addClass('is-invalid');
            label.addClass('is-invalid');
        }

        var $invalidEl = $(document).find('.is-invalid').parent();

        if ($invalidEl.length && $('.create-account-form').length) {
            var $header = $('header');
            var headerHeight = $header.length ? $header.height() : 0;
            var target = $invalidEl.eq(0).offset().top - headerHeight;
            $('html, body').animate({
                scrollTop: target
            }, 0);
        }
    }
}

/**
 * Reinit validation events
 * @returns {void}
 */
function reinitValidation() {
    $('form input, form select, form textarea').off('invalid', showErrors).on('invalid', showErrors);
}

/**
 * Change required status of all address details except state, country, and postal code
 * @param {Object} countryData - data validation schema for particular country
 */
function otherAddressRequirements(countryData) {
    var fieldsToDo = ['address1', 'city'];
    if (countryData && countryData.dynamicForms && countryData.dynamicForms.addressDetails) {
        fieldsToDo.forEach(function (field) {
            if (countryData.dynamicForms.addressDetails[field]) {
                var fieldIsRequired = countryData.dynamicForms.addressDetails[field].required;
                $('#' + field).prop('required', fieldIsRequired);
                var formGroup = $('#' + field).closest('.form-group');
                if (fieldIsRequired && !formGroup.hasClass('required')) {
                    formGroup.addClass('required');
                }

                if (!fieldIsRequired && formGroup.hasClass('required')) {
                    formGroup.removeClass('required');
                }
            }
        });
    }
}

module.exports = {
    selectCountryUpdate: function () {
        $(document).on('change', '.country-select', function (e) {
            var actionPage = $('.page').data('action');
            e.preventDefault();
            var $this = $(this);
            var selectedCountryCode = $this.find('option:selected').attr('id') || $this.find('option[selected]').attr('id');
            var countryListVal = $('#countryList').val();
            var countryListObj = JSON.parse(countryListVal);
            var countryData = countryListObj[selectedCountryCode];
            var phonePrefix = countryData && countryData.phonePrefix ? countryData.phonePrefix : '';
            var shippingPhone = $('.shippingPhoneNumber');
            var $accountPhone = $('.phone-number-prefix');

            if (!$this.closest('.custom-dropdown-container').parent().hasClass('tbd-country-wrapper')) {
                if (phonePrefix || selectedCountryCode === 'OT') {
                    shippingPhone.val(phonePrefix);
                }
                // updated the phone country code only if the user did not enter the phone number
                if ($accountPhone.val() && $accountPhone.val().length < 10) {
                    $accountPhone.val(phonePrefix);
                }
            }

            buildStateSelector(selectedCountryCode, $this, e);
            buildPostalInput(selectedCountryCode, $this);
            var $stateWrapper = $('.state-select-wrapper');
            if (selectedCountryCode !== 'US') {
                if (actionPage === 'Account-TradeSignup' && selectedCountryCode === 'OTHER' && $('.country-input-row').length === 0) {
                    // Handle free text input
                    var name = $(this).attr('name');
                    var countryInput = '<div class="row country-input-row">'
                    + '<div class="form-group col-12 required">'
                    + '<label class="form-control-label" for="' + name + '" >OTHER COUNTRY</label>'
                    + '<input required type="text" name="' + name + '" class="country-input form-control" />'
                    + '</div>'
                    + '</div';
                    $stateWrapper.after(countryInput);
                    $(this).prop('disabled', true);
                    $('#otherCountry').prop('checked', true);
                    $('#otherCountry').val(true);
                } else if (actionPage === 'Account-TradeSignup' && selectedCountryCode !== 'OTHER') {
                    $('.country-input-row').remove();
                    $(this).prop('disabled', false);
                    $('#otherCountry').prop('checked', false);
                    $('#otherCountry').val(false);
                }
                $('.address-customs-block').show();
                $('#dwfrm_tradeMasterProfile_licence_businessLicence').prop('required', false);
                $('#dwfrm_tradeMasterProfile_licence_businessLicence').removeClass('is-invalid');
                $('.create-account-licence .file-upload .invalid-feedback').text('');
            } else {
                $('.address-customs-block').hide();
                $('.country-input-row').remove();
                $(this).prop('disabled', false);
                $('#otherCountry').prop('checked', false);
                $('#otherCountry').val(false);
                $('#dwfrm_tradeMasterProfile_licence_businessLicence').prop('required', true);
            }

            otherAddressRequirements(countryData);

            reinitValidation();
        });

        $(document).on('select:changed', function (e, selectDropdown) {
            var selectedText = selectDropdown.find('option:selected').text();
            selectDropdown.closest('.custom-dropdown-container').find('.custom-dropdown-toggle').text(selectedText);
        });
    }
};
